import { PageRowsResponseDTO } from './page-response-dto';
import { ContextRoleProfileApproverRoleDTO } from './context-role-profile-approver-role-dto';

export interface ReadContextRoleProfileApproverRolesResponseDTO extends PageRowsResponseDTO<ContextRoleProfileApproverRoleDTO> {}
